import React, { FC, memo } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import styled from 'styled-components'
import { sv, EColor } from '@ucheba/utils/helpers/styles/variables'
import {
  FullscreenControl,
  GeolocationControl,
  Map,
  Placemark,
  YMaps,
  ZoomControl,
} from 'react-yandex-maps'
import { useOnlyClientRendering } from '@ucheba/utils/hooks/useOnlyClientRendering'
import { yaMapApiKey } from '@ucheba/utils/constants/core'
import { Circle } from '@ucheba/ui/components/Circle/desktop'
import { IEventsLocation } from '../types'
import { useEventPageLocation } from '../bll'

const MapBox = styled.div`
  height: 291px;
  border-radius: ${sv.radius.large};
  overflow: hidden;
`
const AddressBox = styled.div`
  cursor: pointer;
  display: flex;
`

const EventsLocation: FC<IEventsLocation> = (props) => {
  const { locations } = props
  const isClient = useOnlyClientRendering()
  const locationsWithPoint = locations.filter((location) => location.point)
  const { mapData, onAddressClick } = useEventPageLocation(locationsWithPoint)
  const onAddressBoxClick = (location): void =>
    onAddressClick(location?.point?.longitude, location?.point?.latitude)

  if (!locations || !locations.length) return null

  return (
    <>
      <Heading h2='Место проведения' spacing='xxsmall' />

      {locations.map((location) => (
        <AddressBox key={location.id} onClick={() => onAddressBoxClick(location)}>
          <Circle
            color={location.color}
            width='8px'
            style={{ marginRight: '4px', marginTop: '0.5em', flex: '0 0 8px' }}
          />
          <Text>
            {location.address + (location.comment ? ` (${location.comment})` : '')}
          </Text>
        </AddressBox>
      ))}

      <Spacing spacing='small' />

      {locationsWithPoint.length > 0 && (
        <MapBox>
          {isClient && (
            <YMaps query={{ apikey: yaMapApiKey }} modules={['geocode']}>
              <Map state={mapData} width='100%' height='291px'>
                <ZoomControl />

                <FullscreenControl />

                <GeolocationControl />
                {locationsWithPoint.map((location) => (
                  <Placemark
                    key={`${location?.point?.longitude}${location.point?.latitude}`}
                    geometry={[location?.point.longitude, location?.point.latitude]}
                    options={{ iconColor: EColor[location.color] }}
                  />
                ))}
              </Map>
            </YMaps>
          )}
        </MapBox>
      )}

      <Spacing spacing='xlarge' />
    </>
  )
}

export default memo(EventsLocation)
